import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Page title
document.title = 'Księgowość';
// OG / Social preview meta tags
const setMeta = (property: string, content: string, isName = false) => {
  const attr = isName ? 'name' : 'property';
  let el = document.querySelector(`meta[${attr}="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};
// Open Graph
setMeta('og:type', 'website');
setMeta('og:title', 'Usługi księgowe dla firm — demo od Jetly');
setMeta('og:description', 'To jest strona demonstracyjna. Możemy stworzyć taką samą dla Twojego biznesu — od 199 €. Złóż zamówienie na jetly.agency');
setMeta('og:url', 'https://jetly.agency/ua');
setMeta('og:site_name', 'Jetly Agency');
// Twitter / X
setMeta('twitter:card', 'summary_large_image', true);
setMeta('twitter:title', 'Usługi księgowe — demo od Jetly', true);
setMeta('twitter:description', 'To jest strona demonstracyjna. Możemy stworzyć taką samą dla Twojego biznesu — od 199 €. Złóż zamówienie na jetly.agency', true);
// Description for SEO
setMeta('description', 'To jest demonstracyjna strona usług księgowych. Jetly Agency może dostosować ten design lub stworzyć stronę od zera dla Twojego biznesu od 199 €.', true);
render(<App data-id="element-375" />, document.getElementById('root'));